import SEO from "../../components/seo/SEO";
import { useFetchLoans } from "../../hooks/fetch-data/useFetchLoans";
import LoanDetail from "./LoanDetail";
import { useTranslation } from "react-i18next";

const PersonalLoanDetailPage = () => {
  const { t } = useTranslation("loanDetail");

  const { data: loans, isFetching: isFetchingLoans } = useFetchLoans();

  const loanInfo = loans?.[0]; // First product

  return (
    <>
      <SEO
        title={t("personal.title")}
        description={t("personal.description")}
        url={window.location.href}
        imageUrl={`${window.location.origin}/assets/img/ci/icon/icon-aunjai.svg`}
      />
      <LoanDetail loanInfo={loanInfo} isFetchingLoans={isFetchingLoans} />
    </>
  );
};

export default PersonalLoanDetailPage;
